import React, { useMemo } from "react";
import BaseChart from "../../components/ui/BaseChart";

const HOURS = Array.from({ length: 24 }, (_, i) =>
  i === 0 ? "12am" : i < 12 ? `${i}am` : i === 12 ? "12pm" : `${i - 12}pm`,
);

const HourlyActivityChart = ({ data }) => {
  const peak = useMemo(() => {
    if (!data?.length) return -1;
    return data.indexOf(Math.max(...data));
  }, [data]);

  const chartOptions = useMemo(
    () => ({
      chart: {
        type: "column",
        height: 200,
        margin: [16, 8, 36, 32],
        backgroundColor: "transparent",
      },
      title: { text: null },
      xAxis: {
        categories: HOURS,
        lineColor: "#e5e7eb",
        tickLength: 0,
        labels: {
          step: 3,
          style: { fontSize: "9px", color: "#9ca3af" },
        },
      },
      yAxis: {
        title: { text: null },
        gridLineColor: "#f3f4f6",
        labels: { style: { fontSize: "9px", color: "#bbb" } },
        min: 0,
      },
      legend: { enabled: false },
      tooltip: {
        formatter() {
          return `<b>${HOURS[this.x] ?? this.x}</b>: ${this.y} work orders`;
        },
        backgroundColor: "#1e293b",
        style: { color: "#f8fafc" },
        borderWidth: 0,
        borderRadius: 6,
      },
      plotOptions: {
        column: {
          borderRadius: 3,
          borderWidth: 0,
          pointPadding: 0.05,
          groupPadding: 0.05,
        },
      },
      series: [
        {
          name: "Work Orders",
          data: (data ?? Array(24).fill(0)).map((v, i) => ({
            y: v,
            color: i === peak && v > 0 ? "#0F40AE" : i >= 9 && i <= 17 ? "#93C5FD" : "#CBD5E1",
          })),
        },
      ],
    }),
    [data, peak],
  );

  return (
    <div>
      <BaseChart options={chartOptions} className="w-full" />
      <div className="flex justify-center gap-4 mt-1 text-[10px] text-gray-400">
        <span className="flex items-center gap-1">
          <span className="inline-block w-2.5 h-2.5 rounded-sm bg-[#0F40AE]" /> Peak hour
        </span>
        <span className="flex items-center gap-1">
          <span className="inline-block w-2.5 h-2.5 rounded-sm bg-[#93C5FD]" /> Business hours
        </span>
        <span className="flex items-center gap-1">
          <span className="inline-block w-2.5 h-2.5 rounded-sm bg-[#CBD5E1]" /> Off-hours
        </span>
      </div>
    </div>
  );
};

export default HourlyActivityChart;
